// Copyright 2019 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     https://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/** @module common-sk/modules/dom */ /**
 * A Promise that resolves when DOMContentLoaded has fired.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DomReady: function() {
        return DomReady;
    },
    $: function() {
        return $;
    },
    $$: function() {
        return $$;
    },
    findParent: function() {
        return findParent;
    },
    findParentSafe: function() {
        return findParentSafe;
    }
});
const DomReady = new Promise((resolve)=>{
    if (document.readyState !== 'loading') {
        // If readyState is already past loading then
        // DOMContentLoaded has already fired, so just resolve.
        resolve(undefined);
    } else {
        document.addEventListener('DOMContentLoaded', resolve);
    }
});
function $(query, ele = document) {
    return Array.from(ele.querySelectorAll(query));
}
function $$(query, ele = document) {
    return ele.querySelector(query);
}
function findParent(ele, nodeName) {
    while(ele !== null){
        if (ele.nodeName === nodeName) {
            return ele;
        }
        ele = ele.parentElement;
    }
    return null;
}
function findParentSafe(ele, nodeName) {
    while(ele !== null){
        if (ele.nodeName.toLowerCase() === nodeName) {
            return ele;
        }
        ele = ele.parentElement;
    }
    return null;
}
